export default "__VITE_ASSET__nYTpdDZD__"